<template>
  <div class="container">
    <div class="content" v-html="content"></div>

    <div class="footer-fit">
      <div class="bottom">
        <!-- <div class="left">现在仅需：{{ '￥' + detail.price }}</div> -->
        <div class="right">

          <div class="btn">
            马上报名

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HomeIndex',
  components: {},
  props: {},
  data() {
    return {
      content: '<p><img src=\"https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1830230052270346240.png\"></p><p><img src=\"https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1830230098520936448.png\"><img src=\"https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1830230193534504960.png\"><img src=\"https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1830230227126685696.png\"><img src=\"https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1830230244130394112.png\"><img src=\"https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1830443691170435072.jpg\"></p>'
    }
  }
}
</script>

<style scoped lang="less">
.container {
  color: #333;
  font-size: 28px;

  height: 100%;
  display: flex;
  flex-direction: column;
  .content {
    flex: 1;
    overflow-y: auto;
    ::v-deep img {
      display: block;
      width: 100% !important  ;
    }
  }
}

.header-bg {
  width: 100vw;
}
.footer-fit {
  flex-shrink: 0;

  width: 100%;
  bottom: 0;

  background-color: rgb(255, 250, 240);

  .bottom {
    padding: 20px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fb7633;
  }

  .right {
    width: 100%;
    .btn {
      background-color: rgb(240, 53, 0);
      color: rgb(255, 255, 255);

      height: 100px;
      line-height: 100px;
      border-radius: 50px;
      text-align: center;
      font-size: 44px;

      font-weight: 700;

      .grab {
        font-size: 22px;
        line-height: 22px;
        margin-bottom: 10px;
        padding-top: 15px;
      }
      .enroll {
        line-height: 44px;
        font-weight: 700;
      }
    }
  }
}
</style>
